const ZPUSOBY_PLATBY = {
  0: "Individuálně",
  1: "Příkaz k úhradě",
  2: "Příkaz k inkasu",
  3: "SIPO",
  4: "V hotovosti",
  5: "Složenkou",
  6: "Kreditní kartou",
  7: "Bez úhrady",
  8: "Záloh.fakturou",
  9: "Dobírkou",
  10: "Zápočtem",
};

export default ZPUSOBY_PLATBY;
